export default "__VITE_ASSET__2edee11b__"